import { AdminSubPerfilEnum } from '../../../enum/admin-profiles.enum';
import { SubPerfilEnum } from '../../../enum/default-profiles.enum';
import { PapelEnum } from '../../../enum/Papel/papel.enum';

/** Contexto que desenha o sidebar: app (ERP) ou admin. */
export type ContextoAtalhos = 'app' | 'admin';

export interface AtalhoRapidoDef {
  idSubperfil: number;
  label: string;
  /** true = o `redirectSubperfil` já é o formulário de criação (não acrescenta `/novo`). */
  rotaDireta: boolean;
}

export interface AtalhoRapido {
  idSubperfil: number;
  nomeSubPerfil: string;
  iconeSubperfil: string;
  isNovo: true;
  rotaDireta: boolean;
}

/** ERP: mesmos 5 atalhos de sempre. */
export const CATALOGO_ATALHOS_APP: readonly AtalhoRapidoDef[] = [
  { idSubperfil: SubPerfilEnum.Pedidos, label: 'Venda', rotaDireta: false },
  { idSubperfil: SubPerfilEnum.Produtos, label: 'Produto', rotaDireta: false },
  { idSubperfil: SubPerfilEnum.Clientes, label: 'Cliente', rotaDireta: false },
  { idSubperfil: SubPerfilEnum.Fornecedores, label: 'Fornecedor', rotaDireta: false },
  { idSubperfil: SubPerfilEnum.Usuarios, label: 'Usuário', rotaDireta: false },
];

/**
 * Admin: atalhos de criação da rede. A permissão vem do token do admin (subperfil presente no nó
 * logado + papel de escrita); o tipo do nó já limita o que chega ao token pelo mapa
 * subperfil×tipo (ex.: Interno/Distribuidor não recebem Distribuidores).
 */
export const CATALOGO_ATALHOS_ADMIN: readonly AtalhoRapidoDef[] = [
  { idSubperfil: AdminSubPerfilEnum.NovaEmpresaComercial, label: 'Empresa', rotaDireta: true },
  { idSubperfil: AdminSubPerfilEnum.UsuariosERP, label: 'Usuário app', rotaDireta: false },
  { idSubperfil: AdminSubPerfilEnum.UsuariosAdmin, label: 'Usuário admin', rotaDireta: false },
  { idSubperfil: AdminSubPerfilEnum.Distribuidores, label: 'Distribuidor', rotaDireta: false },
];

interface SubPerfilLike {
  idSubperfil: number;
  idPapel: number;
  redirectSubperfil?: string | null;
  iconeSubperfil?: string | null;
}

/** Só aparece quem tem o subperfil no token E papel de escrita (gravar/total). Lista vazia → o "+" some. */
export function montarAtalhosRapidos(listSubPerfil: SubPerfilLike[] | null | undefined, contexto: ContextoAtalhos): AtalhoRapido[] {
  const catalogo = contexto === 'admin' ? CATALOGO_ATALHOS_ADMIN : CATALOGO_ATALHOS_APP;
  const resultado: AtalhoRapido[] = [];
  for (const def of catalogo) {
    const sp = (listSubPerfil ?? []).find((s) => s.idSubperfil === def.idSubperfil);
    if (!sp?.redirectSubperfil) continue;
    if (sp.idPapel < PapelEnum.lerGravar) continue;
    resultado.push({
      idSubperfil: def.idSubperfil,
      nomeSubPerfil: def.label,
      iconeSubperfil: sp.iconeSubperfil ?? 'add',
      isNovo: true,
      rotaDireta: def.rotaDireta,
    });
  }
  return resultado;
}

/** Segmentos de navegação do atalho: `[prefixo + /rota]` ou `[prefixo + /rota, 'novo']`. */
export function rotaDoAtalho(redirectSubperfil: string, rotaDireta: boolean, prefixo: string): string[] {
  const rota = redirectSubperfil.startsWith('/') ? redirectSubperfil : '/' + redirectSubperfil;
  const base = prefixo + rota;
  return rotaDireta ? [base] : [base, 'novo'];
}
